import { FC } from 'react';

import { useLinkComponent } from '@link';
import { ButtonLink as Props } from '@sitecore/types/manual/ButtonLink';
import { ButtonLink as ButtonLinkComponent } from '@sparky';

export const ButtonLink: FC<Props> = ({ fields, params }) => {
  const Link = useLinkComponent();

  const buttonColor = params.buttonColor
    ? ((params.buttonColor === 'primaryRebrand' ? 'primaryRebrand' : params.buttonColor.toLowerCase()) as
        | 'primary'
        | 'secondary'
        | 'primaryRebrand')
    : undefined;

  return (
    <Link linkType={fields.buttonLink.value.linktype} linkValue={fields.buttonLink.value}>
      <ButtonLinkComponent action={buttonColor} target={fields.buttonLink.value.target ?? undefined}>
        {fields.buttonLink.value.text}
      </ButtonLinkComponent>
    </Link>
  );
};

export default ButtonLink;
